import { usePwaStore } from "@features/pwa";
import { trackAnalytics } from "@shared/libs";
import { clsx } from "clsx";
import { FC, ButtonHTMLAttributes, useEffect, useState } from "react";
import styles from './InstallPwaButtonStyles.module.css';

interface InstallPwaButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onFinish?: () => void;
  onReject?: () => void;
}

export const InstallPwaButton: FC<InstallPwaButtonProps> = (props) => {
  const { children, onClick, disabled, className, onFinish, onReject, ...buttonProps } = props;

  const deferredPrompt = usePwaStore((s: any) => s.deferredPrompt);
  const [isPwaReady, setIsPwaReady] = useState(!!deferredPrompt);

  useEffect(() => {
    if (deferredPrompt) {
      setIsPwaReady(true);
    }
  }, [deferredPrompt]);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);

    if (!deferredPrompt) {
      return;
    }

    trackAnalytics('pwa_install_button_click');
    await deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;

    if (result.outcome === 'accepted') {
      trackAnalytics('pwa_installed');
      setIsPwaReady(false);
      onFinish?.();
    } else {
      onReject?.();
      trackAnalytics('pwa_install_rejected');
    }
  };

  const buttonClassNames = clsx(styles.pwa_button, className);

  return (
    <button onClick={handleClick} disabled={disabled || !isPwaReady} className={buttonClassNames} {...buttonProps}>
      {children || 'Install PWA'}
    </button>
  );
};
